import { atom } from 'recoil';
import { Account } from '../../models/Account';

export const accountState = atom<Account | null>({
  key: 'accountState',
  default: null,
});
